import {
  FETCH_DEALS,
  FETCHING_DEALS_SUCCEEDED,
  FETCHING_DEALS_FAILED,
  FETCH_COMPANY,
  FETCHING_COMPANY_FAILED,
  FETCHING_COMPANY_SUCCEEDED,
  FETCH_STAKEHOLDERS,
  FETCHING_STAKEHOLDERS_SUCCEEDED,
  FETCHING_STAKEHOLDERS_FAILED,
  INVALIDATE_MEETING_DETAILS,
  FETCH_SHARES_FOR_STAKEHOLDERS,
  FETCHING_SHARES_FOR_STAKEHOLDERS_SUCCEEDED,
  FETCHING_SHARES_FOR_STAKEHOLDERS_FAILED,
  FETCH_SIMILAR_DEALS,
  FETCHING_SIMILAR_DEALS_SUCCEEDED,
  FETCHING_SIMILAR_DEALS_FAILED,
  FETCH_DEAL_ROOMS_FOR_STAKEHOLDERS,
  FETCHING_DEAL_ROOMS_FOR_STAKEHOLDERS_SUCCEEDED,
  FETCHING_DEAL_ROOMS_FOR_STAKEHOLDERS_FAILED,
} from "constants/actionTypes";
import _ from "lodash";
import { extractFields } from "services/util";

const initialState = {
  loadingCompanies: false,
  fetchingDeals: false,
  fetchedDeals: false,
  deals: [],
  companies: [],
  loadingStakeholders: false,
  stakeholders: [],
  similarDeals: [],
  dealRooms: {
    loading: false,
    fetched: false,
    items: []
  }
};

function meetingReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_DEALS:
      return Object.assign({}, state, {
        fetchingDeals: true,
        fetchedDeals: false,
      });

    case FETCHING_DEALS_SUCCEEDED:
      return Object.assign({}, state, {
        fetchingDeals: false,
        fetchedDeals: true,
        deals: action.payload.response,
      });

    case FETCHING_DEALS_FAILED:
      return Object.assign({}, state, {
        fetchingDeals: false,
        fetchedDeals: true,
      });

    case FETCH_COMPANY:
      return Object.assign({}, state, {
        loadingCompanies: true,
      });

    case FETCHING_COMPANY_SUCCEEDED:
      const companyResponse = action.payload.response;
      const parsedCompanyResponse = _.map(companyResponse, (company) => {
        const { summary, industry, employeeCount, recentHighlights } = extractFields(company.information, "summary", "industry", "employeeCount", "recentHighlights");
        return {
          ...company,
          summary,
          industry,
          employeeCount,
          recentHighlights
        };
      });

      return Object.assign({}, state, {
        loadingCompanies: false,
        companies: parsedCompanyResponse,
      });

    case FETCHING_COMPANY_FAILED:
      return Object.assign({}, state, {
        loadingCompanies: false,
      });

    case FETCH_STAKEHOLDERS:
      return Object.assign({}, state, {
        loadingStakeholders: true,
      });

    case FETCHING_STAKEHOLDERS_SUCCEEDED:
      const stakeholdersResponse = action.payload.response;
      const parsedResponse = _.map(stakeholdersResponse, (stakeholder) => {
        const { summary, designation } = extractFields(stakeholder.information, "summary", "designation");

        return {
          ...stakeholder,
          summary,
          designation,
        };
      });
      return Object.assign({}, state, {
        loadingStakeholders: false,
        stakeholders: parsedResponse,
      });

    case FETCHING_STAKEHOLDERS_FAILED:
      return Object.assign({}, state, {
        loadingStakeholders: false,
      });

    case FETCH_SHARES_FOR_STAKEHOLDERS:
      return {
        ...state,
        loadingShares: true,
      };

    case FETCHING_SHARES_FOR_STAKEHOLDERS_SUCCEEDED:
      if (action.payload.response.currentPage === 0) {
        return {
          ...state,
          loadingShares: false,
          shares: action.payload.response.records,
          pagination: {
            current: action.payload.response.currentPage,
            totalPages: action.payload.response.totalPages,
          },
        };
      }
      const items = [...state.shares, ...action.payload.response.records];
      const uniqueItems = _.uniqBy(items, "share.id");

      return {
        ...state,
        loadingShares: false,
        shares: uniqueItems,
        pagination: {
          current: action.payload.response.currentPage,
          totalPages: action.payload.response.totalPages,
        },
      };

    case FETCHING_SHARES_FOR_STAKEHOLDERS_FAILED:
      return {
        ...state,
        loadingShares: false,
      };

    case INVALIDATE_MEETING_DETAILS:
      return Object.assign({}, state, initialState);

    case FETCH_SIMILAR_DEALS:
      return {
        ...state,
        similarDeals:{
          loading: true,
          deals: []
        }
      };

    case FETCHING_SIMILAR_DEALS_SUCCEEDED:
      return {
        ...state,
        similarDeals:{
          loading: false,
          deals: action.payload.response
        }
      };

    case FETCHING_SIMILAR_DEALS_FAILED:
      return {
        ...state,
        similarDeals:{
          loading: false,
          deals: []
        }
      }; 
      
    case INVALIDATE_MEETING_DETAILS:
      return {
        ...state,
        similarDeals: {
          loading: false,
          deals: []
        }
      };

      case FETCH_DEAL_ROOMS_FOR_STAKEHOLDERS:
        return {
          ...state,
          dealRooms: {
            loading: true,
            fetched: false,
            items: []
          }
        };

      case FETCHING_DEAL_ROOMS_FOR_STAKEHOLDERS_SUCCEEDED:

        const response = _.get(action.payload, "records", []) || [];
        const dealRooms = response.map((dealRoom) => dealRoom.dealRoom);
        const uniqueDealRooms = _.uniqBy(dealRooms, "id");

        return {
          ...state,
          dealRooms: {
            loading: false,
            fetched: true,
            items: uniqueDealRooms
          }
        };

      case FETCHING_DEAL_ROOMS_FOR_STAKEHOLDERS_FAILED:
        return {
          ...state,
          dealRooms: {
            loading: false,
            fetched: false,
            items: []
          }
        };
    default:
      return state;
  }
}

export { meetingReducer };
